import React, { Component } from "react";

class About extends Component {
  render() {
    return (
      <article className="about-panel" data-panel="about">
        <header className="panel-head">
          <h2 data-en="About Me" data-fa="درباره من">
            About Me
          </h2>
          <span className="head-line"></span>
        </header>
        <p
          className="lead"
          data-en="I believe the best digital products are born where creativity, design, and technology meet.

My journey started with graphic design, evolved into front-end development, and today extends to leading Kama Team, where I help build digital experiences that are not only visually appealing but also solve real problems and create meaningful value.

To me, design is more than aesthetics, development is more than writing code, and content is more than publishing posts—they are all parts of one unified experience that should be purposeful, memorable, and inspiring."
          data-fa="من باور دارم بهترین محصولات دیجیتال از تلفیق خلاقیت، طراحی و فناوری متولد می‌شوند.

مسیر حرفه‌ای من از طراحی گرافیک آغاز شد، با توسعه فرانت‌اند ادامه پیدا کرد و امروز در کنار مدیریت تیم دیجیتال مارکتینگ کاما، روی خلق تجربه‌های دیجیتالی کار می‌کنم که علاوه بر زیبایی، مسئله‌ای را حل کنند و ارزشی واقعی برای کاربران و برندها ایجاد کنند.

برای من طراحی فقط ظاهر نیست، برنامه‌نویسی فقط کدنویسی نیست و محتوا فقط انتشار چند پست نیست؛ همه این‌ها اجزای یک تجربه واحد هستند که باید ماندگار، هدفمند و الهام‌بخش باشد."
        >
          I&apos;m a multidisciplinary designer and front-end developer with a
          passion for minimal interfaces, strong typography and thoughtful
          motion.
        </p>
        <div className="info-grid">
          <div className="info-item">
            <span className="info-k" data-en="Age" data-fa="سن">
              Age
            </span>
            <span className="info-v">22</span>
          </div>
          <div className="info-item">
            <span className="info-k" data-en="Residence" data-fa="محل سکونت">
              Residence
            </span>
            <span className="info-v" data-en="yazd" data-fa="یزد">
              yazd
            </span>
          </div>
          <div className="info-item">
            <span
              className="info-k"
              data-en="Availability"
              data-fa="وضعیت همکاری"
            >
              Availability
            </span>
            <span
              className="info-v"
              data-en="Open to projects"
              data-fa="آماده همکاری"
            >
              Open to projects
            </span>
          </div>
          <div className="info-item">
            <span className="info-k" data-en="Email" data-fa="ایمیل">
              Email
            </span>
            <a className="info-v-email" href="mailto:sftmhzare@gmail.com">
              sftmhzare@gmail.com
            </a>
          </div>
        </div>
        <h3 className="sub-title" data-en="Skills" data-fa="مهارت‌ها">
          Skills
        </h3>
        <div className="skills">
          <div className="skill">
            <div className="skill-top">
              <span data-en="Front-End Development" data-fa="توسعه فرانت‌اند  ">
                Front-End Development
              </span>
              <span>90%</span>
            </div>
            <div className="bar">
              <i style={{ width: "90%" }}></i>
            </div>
          </div>
           <div className="skill">
            <div className="skill-top">
              <span data-en="React Js" data-fa=" ری اکت ">
                React Js
              </span>
              <span>60%</span>
            </div>
            <div className="bar">
              <i style={{ width: "60%" }}></i>
            </div>
          </div>
          <div className="skill">
            <div className="skill-top">
              <span
                data-en="Graphic & Visual Identity Design"
                data-fa="طراحی گرافیک و هویت بصری"
              >
                Graphic & Visual Identity Design
              </span>
              <span>90%</span>
            </div>
            <div className="bar">
              <i style={{ width: "90%" }}></i>
            </div>
          </div>
          <div className="skill">
            <div className="skill-top">
              <span
                data-en=" Content Strategy"
                data-fa="مدیریت و استراتژی محتوای دیجیتال"
              >
                Content Strategy
              </span>
              <span>82%</span>
            </div>
            <div className="bar">
              <i style={{ width: "82%" }}></i>
            </div>
          </div>
          <div className="skill">
            <div className="skill-top">
              <span
                data-en="Digital Content Creation"
                data-fa="تولید محتوای دیجیتال"
              >
                Digital Content Creation
              </span>
              <span>70%</span>
            </div>
            <div className="bar">
              <i style={{ width: "70%" }}></i>
            </div>
          </div>
          <div className="skill">
            <div className="skill-top">
              <span data-en="Video Editor" data-fa="تدوین ویدیو">
                Video Editor
              </span>
              <span>50%</span>
            </div>
            <div className="bar">
              <i style={{ width: "50%" }}></i>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

export default About;
